import { RegisterForm } from "@/features/Auth";

export default function RegisterPage() {
  return <RegisterForm />;
}
